import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useTranslate } from "react-polyglot";
import { makeStyles, withStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import CreditCard from "@material-ui/icons/CreditCardOutlined";
import { amber, indigo } from "@material-ui/core/colors";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import red from "@material-ui/core/colors/red";
import { IS_APP_BEHAPPY, IS_APP_STUDYLESS } from "../../constants.js";
import { useBaseData } from "../../Providers/Data/BaseDataProvider.jsx";
import starIcon from "../../assets/star.svg";
import bellIcon from "../../assets/bell.svg";
import { ReactComponent as BookQueue } from "../../assets/Icons/ic_book-queue_home.svg";
import { ReactComponent as CommentText } from "../../assets/Icons/ic_comment-text_home.svg";
import { ReactComponent as CalendarDates } from "../../assets/Icons/ic_calendar-dates_home.svg";
import { ReactComponent as Newspaper } from "../../assets/Icons/ic_newspaper_home.svg";
import { ReactComponent as Notebook } from "../../assets/Icons/ic_notebook_home.svg";
import { ReactComponent as Edit } from "../../assets/Icons/ic_edit_home.svg";
import { ReactComponent as Trophy } from "../../assets/Icons/ic_trophy_home.svg";
import { useAuth } from "../../Providers/Auth/AuthProvider.jsx";
import HomeTabs from "./HomeTabs.jsx";
import LanguageSelect from "../../SharedComponents/LanguageSelect.jsx";
import LoadingBackdrop from "../../SharedComponents/LoadingBackdrop.jsx";
import FlexboxHorizontal from "../../SharedComponents/FlexboxHorizontal.jsx";
import FlexboxVertical from "../../SharedComponents/FlexboxVertical.jsx";
import PushNotification from "../../SharedComponents/PushNotification.jsx";
import { isNotificationsSupported } from "../../Utils/firebase.js";
import useFavicon from "../../hooks/useFavicon.js";
import useTabsRouter from "../../hooks/useTabsRouter.js";
import AccessDaysWarningBar from "./HomeComponents/AccessDaysWarningBar.jsx";
import useEffectWithPreviousValues from "../../hooks/useEffectWithPreviousValues.js";
import { useDialogs } from "../../Providers/Common/DialogsProvider.jsx";
import LockDialog from "../../SharedComponents/LockDialog.jsx";
import ViewportMeta from "../../SharedComponents/ViewportMeta.jsx";
import { useEvents } from "../../Providers/Data/EventsProvider.jsx";
import { useNews } from "../../Providers/Data/NewsProvider.jsx";
import { useChat } from "../../Providers/Data/ChatProvider.jsx";
import InactiveUserBar from "./HomeComponents/InactiveUserBar.jsx";

const useStyles = makeStyles((theme) => ({
  mainBox: {
    backgroundColor: "#E2E4E5",
  },
  appBar: {
    boxShadow: "none",
    // background: theme.palette.primary.main,
  },
  toolbar: {
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
      width: "100%",
      height: "max-content",
    },
  },
  startEndBoxes: {
    alignItems: "center",
    color: "white",
    [theme.breakpoints.down("md")]: {
      order: 1,
    },
  },
  tabsContainer: {
    "& .MuiTabs-root": {
      backgroundColor: "#F1F2F2",
      borderRadius: 21,
      padding: 4,
      height: 42,
      minHeight: 42,
      "& .MuiTabs-indicator": {
        display: "none",
      },
      "& .MuiTabs-flexContainer": {
        gap: 12,
      },
    },
    [theme.breakpoints.down("md")]: {
      order: 2,
      flex: "100%",
      marginTop: 12,
      marginBottom: 16,
    },
  },
  divider: {
    height: 16,
    width: 2,
    backgroundColor: "#C5C7C9",
    margin: "0 12px",
  },
  star: {
    marginBottom: 2,
  },
  notification: {
    padding: 4,
    height: 32,
    "& .MuiIconButton-label": {
      marginTop: 6,
    },
  },
  notificationIcon: {
    display: "inline-block",
    position: "relative",
  },
  leaderPoints: {
    color: "#54606B",
    fontSize: 14,
    fontWeight: 500,
    margin: "0 0 0 4px",
  },
  menuText: {
    margin: "0 0 0 5px",
  },
  userIconButton: {
    padding: 5,
    "& .MuiSvgIcon-root": {
      fill: "#54606B",
    },
    "& img": {
      borderRadius: "50%",
      overflow: "hidden",
      display: "block",
      objectFit: "cover",
      objectPosition: "center",
    },
  },
  pointsButton: {
    padding: "4px 5px",
    minWidth: "max-content",
    position: "relative",
    "&.MuiButton-root.Mui-disabled": {
      color: "#54606B",
      opacity: 1,
    },
  },
  positionBox: {
    position: "absolute",
    width: 20,
    textAlign: "center",
    color: "#54606B",
    fontSize: 11,
    left: 8,
  },
  schoolIconButton: {
    padding: "0 7px 0 0",
    minWidth: 0,
    textTransform: "none",
    "& img": {
      borderRadius: 4,
      overflow: "hidden",
      display: "block",
      objectFit: "cover",
      objectPosition: "center",
      flexShrink: 0,
    },
    "& .MuiTypography-colorPrimary": {
      fontSize: 16,
      fontWeight: 500,
      marginLeft: 6,
    },
  },
  warningBar: {
    minHeight: 50,
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
  },
  warningBarIcon: {
    marginRight: 50,
  },
  warningBarButton: {
    marginLeft: 50,
  },
  inactiveUserBar: {
    backgroundColor: amber[400],
    color: indigo[900],
  },
  accessDaysWarningBar: {
    backgroundColor: red[700],
    color: "white",
  },
  accessDemoDaysWarningBar: {
    backgroundColor: "#53AE67",
    color: "white",
  },
  sadIcon: {
    marginRight: 20,
  },
  inactiveUserBarText: {
    fontWeight: 600,
  },
  moreButton: {
    marginLeft: 20,
  },
  inactiveUserDialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: 30,
  },
  inactiveUserDialogContentSadIcon: {
    width: 60,
    height: 60,
  },
  inactiveUserDialogContentText: {
    textAlign: "center",
    fontSize: 17,
    fontWeight: 600,
    color: indigo[900],
    marginTop: 20,
  },
  inactiveUserDialogContentCompanyName: {
    textAlign: "center",
    fontSize: 27,
    fontWeight: 600,
    marginTop: 10,
  },
  inactiveUserDialogContentCompanyContacts: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: 500,
    marginTop: 8,
    "& a": {
      textDecoration: "none",
      color: "inherit",
    },
  },
}));

/** */
const Home = () => {
  const classes = useStyles();
  const history = useHistory();
  const t = useTranslate();
  const { signOut, company2 } = useAuth();
  const { company, userInfo, leaderboard, getResources, levelsAndReward } = useBaseData();
  const [myPoints, setMyPoints] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const { alert } = useDialogs();
  const { tabIndex, onTabChanged } = useTabsRouter([
    "/",
    "/dictionary",
    "/homeworks",
    "/events",
    "/news",
    "/missions",
    "/chat",
  ]);
  const { unwatchedCount: unwatchedEventsCount } = useEvents();
  const { unwatchedNews } = useNews();
  const { unreadConversationsCount } = useChat();
  const [tabsView, setTabsView] = useState(true);
  const [subjectPoints, setSubjectPoints] = useState(0);
  const [leaderboardPosition, setLeaderboardPosition] = useState(0);

  useFavicon();

  // Если отключено всё, кроме самого курса, то не показываем табы
  useEffect(() => {
    if (
      !userInfo.subject.dictionaryEnabled &&
      !userInfo.subject.homeworksEnabled &&
      !userInfo?.subject?.eventSettings?.isEventsListAvailable &&
      !userInfo.subject.missionsEnabled &&
      !userInfo.isChatAvailable
    ) {
      setTabsView(false);
    } else {
      setTabsView(true);
    }
  }, [userInfo]);

  const location = history.location.pathname;

  // Update levels on return back to home
  useEffectWithPreviousValues(
    ([prevLocation]) => {
      if (prevLocation && prevLocation !== "/" && location === "/") {
        const resources = ["levels"];
        if (prevLocation === "/chat") {
          // Переход мог быть осуществлён программно по причине отключения чата,
          // поэтому нужно обновить данные пользователя
          resources.push("userInfo");
        }
        getResources(resources).then();
      }
    },
    [location],
  );

  /** */
  const reqNotifPermission = () => {
    if (!isNotificationsSupported()) return;

    Notification.requestPermission().then();
  };

  /** */
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  /** @param {Event} event */
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /** */
  const onProfile = () => {
    handleMenuClose();
    history.push("/profile");
  };

  /** */
  const onOrders = () => {
    handleMenuClose();
    history.push("/orders");
  };

  /** */
  const onPoints = () => {
    if (!userInfo.subject.showLeaderboard) return;
    history.push("/leaderboard");
  };

  // update points
  useEffect(() => {
    if (leaderboard.length) {
      leaderboard.forEach((item, index) => {
        if (item.id === userInfo.id) {
          setMyPoints(item.points);
          setLeaderboardPosition(index + 1);
        }
      });
    } else {
      if (levelsAndReward?.levels) {
        setMyPoints(
          levelsAndReward?.levels.reduce((acc, level) => {
            return (acc += level.havePoints);
          }, 0),
        );
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaderboard, levelsAndReward?.levels]);

  // Subject points
  useEffect(() => {
    if (levelsAndReward?.levels) {
      setSubjectPoints(
        levelsAndReward?.levels.reduce((acc, level) => {
          return (acc += level.points);
        }, 0),
      );
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [levelsAndReward?.levels]);

  /** */
  const schoolClickHandler = () => {
    history.push("/");
  };

  /** */
  const logoutClickHandler = () => {
    signOut();
  };

  const menuId = "account-menu";
  const isMenuOpen = Boolean(anchorEl);

  /** */
  const notificationButtonHandler = () => {
    alert({
      onConfirm: reqNotifPermission,
      title: t("notificationsAlert.permissionDefault.title"),
      message: t("notificationsAlert.permissionDefault.body"),
      confirmText: t("notificationsAlert.subscribe"),
    });
  };

  return (
    <>
      <ViewportMeta
        // Установка масштаба страницы, позволяющего увидеть весь контент на телефонах
        initialScale={0.4}
        // Возможность менять масштаб страницы двумя пальцами (Pinch to zoom)
        userScalable
      />
      <FlexboxVertical className={classes.mainBox} justifyContent="flex-start" alignItems="center" height="100vh">
        <PushNotification />
        <AppBar className={classes.appBar} position="relative">
          <Toolbar className={classes.toolbar}>
            <FlexboxHorizontal className={classes.startEndBoxes} data-tag="left edge">
              <Button className={classes.schoolIconButton} color="inherit" onClick={schoolClickHandler}>
                <img src={company2?.logo.url || company.logo.url} alt="logo" height={40} width={40} />
                <Typography color="primary">{company.name}</Typography>
              </Button>
            </FlexboxHorizontal>
            {tabsView && (
              <Box className={classes.tabsContainer}>
                <Tabs variant="fullWidth" value={tabIndex} indicatorColor="primary" onChange={onTabChanged}>
                  <StyledTab label={<StyledLabel label={t("course")} />} icon={<BookQueue />} />
                  <StyledTab
                    label={<StyledLabel label={t("dictionary")} />}
                    icon={<Notebook />}
                    style={{ display: userInfo.subject.dictionaryEnabled ? undefined : "none" }}
                  />
                  <StyledTab
                    label={<StyledLabel label={t("homeworks.tabName")} />}
                    icon={<Edit />}
                    style={{ display: userInfo.subject.homeworksEnabled ? undefined : "none" }}
                  />
                  <StyledTab
                    label={<StyledLabel label={t("events")} badgeContent={unwatchedEventsCount} />}
                    icon={<CalendarDates />}
                    style={{ display: userInfo?.subject?.eventSettings?.isEventsListAvailable ? undefined : "none" }}
                  />
                  <StyledTab
                    label={<StyledLabel label={t("news")} badgeContent={unwatchedNews?.length} />}
                    icon={<Newspaper />}
                  />
                  <StyledTab
                    label={<StyledLabel label={t("missions.title")} />}
                    icon={<Trophy />}
                    style={{ display: userInfo.subject.missionsEnabled ? undefined : "none" }}
                  />
                  <StyledTab
                    label={<StyledLabel label={t("chat.tabLabel")} badgeContent={unreadConversationsCount} />}
                    icon={<CommentText />}
                    style={{ display: userInfo.isChatAvailable ? undefined : "none" }}
                  />
                </Tabs>
              </Box>
            )}
            <FlexboxHorizontal className={classes.startEndBoxes} data-tag="right edge">
              <LanguageSelect buttonProps={{ className: classes.langButton }} />
              <Divider className={classes.divider} orientation="vertical" />
              {!IS_APP_STUDYLESS && !IS_APP_BEHAPPY && (
                <>
                  <Button
                    className={classes.pointsButton}
                    onClick={onPoints}
                    disabled={!userInfo.subject.showLeaderboard}
                  >
                    {userInfo.subject.showLeaderboard && (
                      <>
                        <img className={classes.star} src={starIcon} alt="star" width={28} />
                        <div className={classes.positionBox}>{leaderboardPosition}</div>
                      </>
                    )}
                    {userInfo.subject.leaderboardPerDay ? (
                      <Typography className={classes.leaderPoints} variant="body2">
                        {myPoints}
                      </Typography>
                    ) : (
                      <Typography className={classes.leaderPoints} variant="body2">
                        {`${myPoints}/${subjectPoints}`}
                      </Typography>
                    )}
                  </Button>
                  <Divider className={classes.divider} orientation="vertical" />
                </>
              )}
              {isNotificationsSupported() && Notification.permission === "default" && (
                <>
                  <IconButton onClick={notificationButtonHandler} className={classes.notification}>
                    <div className={classes.notificationIcon}>
                      <img className={classes.star} src={bellIcon} alt="bellIcon" />
                    </div>
                  </IconButton>
                  <Divider className={classes.divider} orientation="vertical" />
                </>
              )}
              <IconButton className={classes.userIconButton} color="inherit" onClick={handleProfileMenuOpen}>
                {userInfo?.photo?.url ? (
                  <img src={userInfo?.photo?.url} alt="photo user" height={30} width={30} />
                ) : (
                  <AccountCircleOutlinedIcon />
                )}
              </IconButton>
            </FlexboxHorizontal>
          </Toolbar>
        </AppBar>
        <InactiveUserBar classes={classes} />
        <AccessDaysWarningBar classes={classes} />
        <Menu
          anchorEl={anchorEl}
          id={menuId}
          keepMounted
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          getContentAnchorEl={null}
          open={isMenuOpen}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={onProfile}>
            <AccountCircleOutlinedIcon />
            <Typography className={classes.menuText}>{t("profile")}</Typography>
          </MenuItem>
          <MenuItem onClick={onOrders}>
            <CreditCard />
            <Typography className={classes.menuText}>{t("orders")}</Typography>
          </MenuItem>
          <MenuItem onClick={logoutClickHandler}>
            <PowerSettingsNewIcon />
            <Typography className={classes.menuText}>{t("logout")}</Typography>
          </MenuItem>
        </Menu>
        <HomeTabs />
        <LoadingBackdrop />
      </FlexboxVertical>
      <LockDialog />
    </>
  );
};

const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: "max-content",
    textTransform: "none",
    padding: "8px 12px",
    height: 34,
    borderRadius: 16,
  },
  wrapper: {
    flexDirection: "row",
    "& svg": {
      flexShrink: 0,
    },
  },
  labelIcon: {
    minHeight: 34,
    "& .MuiTab-wrapper > *:first-child": {
      marginBottom: 3,
    },
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "& path": {
      opacity: 1,
      stroke: "#fff",
    },
    "& #home path": {
      fill: "#fff",
      stroke: "none",
    },
    "& #badgeTab": {
      color: "#fff",
    },
  },
}))(Tab);

const useLabelStyles = makeStyles((theme) => ({
  label: {
    color: "inherit",
    fontSize: 14,
    lineHeight: 1.25,
    fontWeight: 500,
  },
  badge: {
    fontSize: 12,
    lineHeight: 1.25,
    color: "#1B1C1C",
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    borderRadius: 4,
    marginLeft: 8,
    padding: "2px 2px 0 2px",
  },
}));

/** */
const StyledLabel = ({ badgeContent, label }) => {
  const classes = useLabelStyles();
  return (
    <Box display="flex" ml={0.75}>
      <Typography className={classes.label}>{label}</Typography>
      {badgeContent > 0 && (
        <Typography id="badgeTab" className={classes.badge}>
          {badgeContent}
        </Typography>
      )}
    </Box>
  );
};

StyledLabel.propTypes = {
  badgeContent: PropTypes.any,
  label: PropTypes.string.isRequired,
};

export default Home;
